import React from "react";
import TextField from "@material-ui/core/TextField";
import { connect, useSelector } from "react-redux";
import * as advertRedux from "modules/Advert/_redux/advertRedux";

// Seller (Satılık) ilan: aracın model yılı (tek sayı).
// Redux: newAdvert.filters.year. Backend create akışı bunu üst seviye advert.year'a taşır.
function FLYearInput(props) {
  const { filters } = useSelector((state) => ({
    filters: state.advert.newAdvert.filters,
  }));

  const value = filters?.year ?? "";
  const currentYear = new Date().getFullYear();

  return (
    <TextField
      type="number"
      label={props.filter.title || "Yıl"}
      variant="outlined"
      margin="dense"
      fullWidth
      value={value}
      onChange={(e) =>
        props.editNewAdvertFilters(
          "year",
          e.target.value === "" ? "" : Number(e.target.value)
        )
      }
      inputProps={{ min: 1900, max: currentYear + 1 }}
      placeholder={String(currentYear)}
    />
  );
}

export default connect(null, { ...advertRedux.actions })(FLYearInput);
